/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input, Typography } from 'antdV4';
import { Row, Col, Select } from 'antd';
import { EMemberRequestToPartnerStatus2 } from '../dto/member-request-to-partner.dto';
import fitMemberToPartnerServices from '../../../../../services/fit-member-to-partner.services';

const MemberRequestToPartnerForm = () => {
  const { watch, reset, control } = useFormContext();

  fitMemberToPartnerServices.useQueryGetMemberRequestToPartnerById(
    {
      memberRequestToPartnerId: watch('id'),
    },
    (data) => {
      reset({
        ...data,
        StaffRemark: data.StaffRemark ? data.StaffRemark : '',
        formType: 'edit',
      });
    }
  );

  return (
    <div>
      <Controller
        name="Status"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>การตอบกลับ</Typography.Text>
              </Col>
              <Col span={20}>
                <Select
                  value={value}
                  style={{ width: 200, marginRight: 10 }}
                  onChange={(status) => {
                    onChange(status);
                  }}
                  placeholder="สถานะ"
                  disabled={value === 'completed'}
                >
                  {EMemberRequestToPartnerStatus2.map((item) => {
                    return (
                      <Select.Option
                        key={item.value}
                        value={item.value}
                        disabled={item.value === 'completed'}
                      >
                        {item.label}
                      </Select.Option>
                    );
                  })}
                </Select>
              </Col>
            </Row>
          );
        }}
      />
      <Controller
        name="StaffRemark"
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <Row className="align-items-center  mb-2">
              <Col span={4}>
                <Typography.Text>หมายเหตุ</Typography.Text>
              </Col>
              <Col span={20}>
                <Input.TextArea
                  rows={3}
                  value={value}
                  onChange={onChange}
                  placeholder=""
                />
              </Col>
            </Row>
          );
        }}
      />
    </div>
  );
};

export default MemberRequestToPartnerForm;
